import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const CustomProductItem = Scrivito.provideObjClass("CustomProductItem", {
  attributes: {
    body: ["widgetlist", { only: "SectionWidget" }],
    isProdReady: "boolean",
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: ["body", "title", "subtitle"],
});

export default CustomProductItem;
